import { useState, useEffect } from 'react';
import { Dimensions } from '@/shared/theme';

export type ViewType = 'mobile' | 'desktop';

export interface DeviceDimensions {
  viewType: ViewType;
  isDesktopDimensions: boolean;
  isMobileDimensions: boolean;
  width: number;
}

/**
 * Hook to detect device dimensions and viewport breakpoint
 * Uses 1000px (Dimensions.gridWidth) as the breakpoint between mobile and desktop
 * @returns DeviceDimensions object with viewport information
 */
export const useDeviceDimensions = (): DeviceDimensions => {
  const [dimensions, setDimensions] = useState<DeviceDimensions>(() => {
    const width = window.innerWidth;
    const isMobile = width < Dimensions.gridWidth;
    return {
      viewType: isMobile ? 'mobile' : 'desktop',
      isDesktopDimensions: !isMobile,
      isMobileDimensions: isMobile,
      width,
    };
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const isMobile = width < Dimensions.gridWidth;
      setDimensions({
        viewType: isMobile ? 'mobile' : 'desktop',
        isDesktopDimensions: !isMobile,
        isMobileDimensions: isMobile,
        width,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return dimensions;
};
